const translations = {
  "Weekly Metrics": "Métricas Semanales",
  "Total initial capital": "Capital inicial total",
  "Initial capital": "Capital inicial",
  "Week": "Semana",
  "Profit": "Ganancia",
  "Net Profit": "Ganancia Neta",
  "Return on Initial Equity": "Retorno sobre Capital Inicial",
  "Return on Total Equity": "Retorno sobre Capital Total",
  "Trades": "Operaciones",
  "Profit Factor": "Factor de Ganancia",
  "Percent Profitable Trades": "Porcentaje Operaciones Rentable",
  "TradeList": "Lista de Operaciones",
  "Search": "Buscar",
  "Source": "Fuente",
  "Type": "Tipo",
  "Date": "Fecha",
  "Price": "Precio",
  "Quantity": "Cantidad",
  "Cumulative Profit": "Ganancia Acumulada",
  "Cumulative Profit %": "Ganancia Acumulada %",
  "Settings": "Configuraciones",
  "Show file info on import page": "Mostrar información del archivo en la página de importación",
  "Dark Mode": "Modo Oscuro",
  "Show Currency Symbol": "Mostrar Símbolo de Moneda",
  "Currency Symbol": "Símbolo de Moneda",
  "Language": "Idioma",
  "Monthly Metrics": "Métricas Mensuales",
  "Month": "Mes",
  "Import Data": "Importar Datos",
  "Drag & drop some files here, or click to select files": "Arrastra y suelta algunos archivos aquí, o haz clic para seleccionar archivos",
  "Show file infos": "Mostrar información del archivo",
  "Include All": "Incluir Todo",
  "Include None": "No Incluir Nada",
  "Remove All": "Eliminar Todo",
  "Include": "Incluir",
  "Name": "Nombre",
  "File Name": "Nombre del Archivo",
  "Lines": "Líneas",
  "Initial Equity": "Capital Inicial",
  "Recalculated Initial Equity": "Capital Inicial Recalculado",
  "No files uploaded yet.": "No se han subido archivos todavía.",
  "Confirm Deletion": "Confirmar Eliminación",
  "Are you sure you want to delete": "¿Estás seguro de que quieres eliminar",
  "the file named": "el archivo llamado",
  "all files": "todos los archivos",
  "Cancel": "Cancelar",
  "Confirm": "Confirmar",
  "Dashboard": "Dashboard",
  "Reports": "Informes",
  "Analytics": "Analíticas",
  "Logout": "Cerrar sesión",
  "Main": "Principal",
  "Instructions": "Instrucciones",
  "Imports": "Importaciones",
  "Metrics": "Métricas",
  "Periodical Returns": "Rendimientos Periódicos",
  "Annual": "Anual",
  "Monthly": "Mensual",
  "Weekly": "Semanal",
  "Daily": "Diario",
  "Visuals": "Visuales",
  "Equity Graphs": "Gráficos de Capital",
  "Drawdown Graphs": "Gráficos de Drawdown",
  "Others": "Otros",
  "Disclaimer": "Descargo de responsabilidad",
  "Metric": "Métrica",
  "Value": "Valor",
  "Initial Capital": "Capital Inicial",
  "Total Net Profit": "Ganancia Neta Total",
  "Gross Profit": "Ganancia Bruta",
  "Gross Loss": "Pérdida Bruta",
  "Pessimistic RR": "RR Pesimista",
  "Total Trades": "Total de Operaciones",
  "Winning Trades": "Operaciones Ganadoras",
  "Losing Trades": "Operaciones Perdedoras",
  "Avg Trade Net Profit": "Ganancia Neta Promedio por Operación",
  "Avg Winning Trade": "Operación Ganadora Promedio",
  "Avg Losing Trade": "Operación Perdedoras Promedio",
  "Largest Win": "Mayor Ganancia",
  "Max Cons Winners": "Max Cons Ganadores",
  "Largest Loss": "Mayor Pérdida",
  "Max Cons Losers": "Max Cons Perdedoras",
  "Trading Period": "Período de Trading",
  "Total Trading Days": "Total de Días de Trading",
  "Longest Flat Period Days": "Período Plano Más Largo",
  "Max Drawdown": "Max Drawdown",
  "Max Drawdown As % Of Initial Equity": "Max Drawdown en % del Capital Inicial",
  "Max Drawdown As % Of Total Equity": "Max Drawdown en % del Capital Total",
  "Max Drawdown Date": "Fecha del Max Drawdown",
  "Max Intraday Drawdown": "Max Drawdown Intradía",
  "Max Intraday Drawdown As % Of Initial Equity": "Max Drawdown Intradía en % del Capital Inicial",
  "Max Intraday Drawdown As % Of Total Equity": "Max Drawdown Intradía en % del Capital Total",
  "Max Intraday Drawdown Date": "Fecha del Max Drawdown Intradía",
  "Longest Drawdown Days": "Días de Drawdown Más Largos",
  "Recovery Factor": "Factor de Recuperación",
  "NP Max DD": "NP Max DD",
  "NP Intraday Max DD": "NP Max DD Intradía",
  "Avg Worst 5 DD": "Promedio de los 5 Peores DD",
  "Avg Worst 5 DD As % Of Initial Equity": "Promedio de los 5 Peores DD en % del Capital Inicial",
  "Max Runup": "Max Runup",
  "Max Runup As % Of Initial Equity": "Max Runup en % del Capital Inicial",
  "Max Runup As % Of Total Equity": "Max Runup en % del Capital Total",
  "Max Runup Date": "Fecha del Max Runup",
  "Longest Runup Days": "Días de Runup Más Largos",
  "Margin Requirements": "Requisitos de Margen",
  "Return on Initial Capital": "Retorno sobre Capital Inicial",
  "Annual Rate of Return": "Tasa de Retorno Anual",
  "Avg Monthly Return": "Retorno Mensual Promedio",
  "Std Dev Monthly Return": "Desviación Estándar del Retorno Mensual",
  "Percent Profitable Months": "Porcentaje de Meses Rentables",
  "Sharpe Ratio": "Ratio de Sharpe",
  "Sortino Ratio": "Ratio de Sortino",
  "Sterling Ratio": "Ratio de Sterling",
  "MAR Ratio": "Ratio de MAR",
  "Efficiency Factor": "Factor de Eficiencia",
  "How to Import Your Trading Data:": "Cómo importar tus datos de trading:",
  "Note: There are still calculation bugs. Please use with care.": "Nota: Todavía hay errores de cálculo. Por favor, úsalo con precaución.",
  "Step 1:": "Paso 1:",
  "Export CSV Files from TradingView:": "Exportar archivos CSV desde TradingView:",
  "Open the tab as shown in the image above.": "Abre la pestaña como se muestra en la imagen de arriba.",
  "Click the Download button (also highlighted in the image) to export your trading list as CSV files.": "Haz clic en el botón Descargar (también resaltado en la imagen) para exportar tu lista de trading como archivos CSV.",
  "Step 2:": "Paso 2:",
  "Upload CSV Files to the Application:": "Subir archivos CSV a la aplicación:",
  'Navigate to the "Manage Data" page from the menu.': 'Navega a la página "Gestionar Datos" desde el menú.',
  "Upload the exported CSV files.": "Sube los archivos CSV exportados.",
  "Step 3:": "Paso 3:",
  "Manage Uploaded Files:": "Gestionar archivos subidos:",
  "Each uploaded file can be included in calculations by selecting it.": "Cada archivo subido puede ser incluido en los cálculos seleccionándolo.",
  "You can assign a custom name to each file for better identification.": "Puedes asignar un nombre personalizado a cada archivo para una mejor identificación.",
  "Step 4:": "Paso 4:",
  "Initial Equity Adjustment:": "Ajuste del capital inicial:",
  "The initial amount of equity is estimated by reverse-calculating from your trading data. However, this may not always produce accurate results.": "La cantidad inicial de capital se estima recalculando a partir de tus datos de trading. Sin embargo, esto puede no siempre producir resultados precisos.",
  "After uploading each file, you can manually edit and input the correct initial equity if needed.": "Después de subir cada archivo, puedes editar manualmente e ingresar el capital inicial correcto si es necesario.",
  "Follow these steps to ensure accurate calculations and proper management of your trading data.": "Sigue estos pasos para asegurar cálculos precisos y una gestión adecuada de tus datos de trading.",
  "Loading the magic": "Cargando la magia",
  "Summoning the data wizards": "Invocando a los magos de datos",
  "Hold tight, data incoming": "Aguanta, datos en camino",
  "Just a moment, making things awesome": "Un momento, haciendo cosas geniales",
  "Data elves are at work": "Los elfos de datos están trabajando",
  "Brewing some data potions": "Preparando pociones de datos",
  "Hang on, crunching numbers": "Espera, triturando números",
  "Data is on its way": "Los datos están en camino",
  "Almost there, stay tuned": "Casi allí, mantente atento",
  "Fetching unicorns": "Buscando unicornios",
  "Aligning the stars": "Alineando las estrellas",
  "Polishing the data crystals": "Puliendo los cristales de datos",
  "Warming up the servers": "Calentando los servidores",
  "Gathering the bytes": "Recogiendo los bytes",
  "Charging the flux capacitor": "Cargando el condensador de flujo",
  "Calibrating the data matrix": "Calibrando la matriz de datos",
  "Spinning up the hamster wheels": "Poniendo en marcha las ruedas de hámster",
  "Consulting the oracles": "Consultando a los oráculos",
  "Synchronizing the clocks": "Sincronizando los relojes",
  "Yearly Metrics": "Métricas Anuales",
  "Daily Metrics": "Métricas Diarias",
  "January": "Enero",
  "February": "Febrero",
  "March": "Marzo",
  "April": "Abril",
  "May": "Mayo",
  "June": "Junio",
  "July": "Julio",
  "August": "Agosto",
  "September": "Septiembre",
  "October": "Octubre",
  "November": "Noviembre",
  "December": "Diciembre",
  "Trading Metrics": "Métricas de Trading",
  "Loading...": "Cargando...",
  "Config": "Configuración",
  "Config File Name": "Nombre del archivo de configuración",
  "No config file": "No hay archivo de configuración",
  "Config File Content": "Contenido del archivo de configuración",
  "Confirm Config Deletion": "Confirmar eliminación de configuración",
  "Are you sure you want to delete the config file for": "¿Estás seguro de que quieres eliminar el archivo de configuración para",
  "Close": "Cerrar",
  "tradingRange": "Rango de Trading",
  "backtestingRange": "Rango de Backtesting",
  "symbol": "Símbolo",
  "timeframe": "Intervalo de Tiempo",
  "chartType": "Tipo de Gráfico",
  "pointValue": "Valor del Punto",
  "currency": "Moneda",
  "tickSize": "Tamaño del Tick",
  "precision": "Precisión",
  "initialCapital": "Capital Inicial",
  "orderSize": "Tamaño de la Orden",
  "pyramiding": "Pyramiding",
  "commission": "Comisión",
  "slippage": "Slippage",
  "verifyPriceForLimitOrders": "Verificar Precio para Órdenes Límite",
  "marginForLongPositions": "Margen para Posiciones Largas",
  "marginForShortPositions": "Margen para Posiciones Cortas",
  "recalculateAfterOrderIsFilled": "Recalcular Después de Llenar la Orden",
  "recalculateOnEveryTick": "Recalcular en Cada Tick",
  "recalculateOnBarClose": "Recalcular al Cierre de la Barra",
  "backtestingPrecisionUseBarMagnifier": "Precisión del Backtesting Usar Lupa de Barra",
  "Expert Mode": "Modo Experto",
  "totalNetProfit": "Ganancia Neta Total",
  "grossProfit": "Ganancia Bruta",
  "grossLoss": "Pérdida Bruta",
  "profitFactor": "Factor de Ganancia",
  "totalTrades": "Total de Operaciones",
  "winningTradesCount": "Operaciones Ganadoras",
  "losingTradesCount": "Operaciones Perdedoras",
  "percentProfitable": "Porcentaje Operaciones Rentable",
  "avgTradeNetProfit": "Ganancia Neta Promedio por Operación",
  "avgWinningTrade": "Operación Ganadora Promedio",
  "avgLosingTrade": "Operación Perdedoras Promedio",
  "largestWin": "Mayor Ganancia",
  "largestLoss": "Mayor Pérdida",
  "maxDrawdown": "Max Drawdown",
  "maxDrawdownDate": "Fecha del Max Drawdown",
  "annualRateOfReturn": "Tasa de Retorno Anual",
  "sharpeRatio": "Ratio de Sharpe",
  "sortinoRatio": "Ratio de Sortino",
  "sterlingRatio": "Ratio de Sterling",
  "marRatio": "Ratio de MAR",
  "efficiencyFactor": "Factor de Eficiencia",
  "returnOnInitialCapital": "Retorno sobre Capital Inicial",
  "marginRequirements": "Requisitos de Margen",
  "maxDrawdownAsPercentOfInitialEquity": "Max Drawdown en % del Capital Inicial",
  "maxDrawdownAsPercentOfTotalEquity": "Max Drawdown en % del Capital Total",
  "maxIntradayDrawdownAsPercentOfInitialEquity": "Max Drawdown Intradía en % del Capital Inicial",
  "maxIntradayDrawdownAsPercentOfTotalEquity": "Max Drawdown Intradía en % del Capital Total",
  "recoveryFactor": "Factor de Recuperación",
  "npMaxDD": "NP Max DD",
  "npIntradayMaxDD": "NP Max DD Intradía",
  "avgWorst5DD": "Promedio de los 5 Peores DD",
  "maxRunupAsPercentOfInitialEquity": "Max Runup en % del Capital Inicial",
  "maxRunupAsPercentOfTotalEquity": "Max Runup en % del Capital Total",
  "maxIntradayRunupAsPercentOfInitialEquity": "Max Runup Intradía en % del Capital Inicial",
  "maxIntradayRunupAsPercentOfTotalEquity": "Max Runup Intradía en % del Capital Total",
  "maxIntradayRunupDuration": "Duración del Max Runup Intradía",
  "maxIntradayRunup": "Max Runup Intradía",
  "maxIntradayRunupDate": "Fecha del Max Runup Intradía",
  "Select Metrics": "Seleccionar Métricas",
  "Additional Expert Mode Metrics": "Métricas Adicionales en Modo Experto",
  "Select All": "Seleccionar Todo",
  "Deselect All": "Deseleccionar Todo",
  "Open Metrics Popup": "Abrir Ventana de Métricas",
  "View and Select Metrics": "Ver y Seleccionar Métricas",
  "Show Advanced Metrics": "Mostrar Métricas Avanzadas",
  "Monthly Profit and Loss": "Ganancias y Pérdidas Mensuales",
  "Monthly Graphs": "Gráficos Mensuales",
  "(Optional) How to Import And Remember Your Backtest Configuration:": "(Opcional) Cómo Importar y Recordar su Configuración de Backtest:",
  "Export Configuration:": "Exportar Configuración:",
  "Navigate to the 'Configuration' page in the TradingView backtester.": "Navegue a la página 'Configuración' en el backtester de TradingView.",
  "Click the 'Export' button to save your current configuration.": "Haga clic en el botón 'Exportar' para guardar su configuración actual.",
  "Import Configuration:": "Importar Configuración:",
  "Click the 'Import' button in the config column of your entries row and upload the exported csv file.": "Haga clic en el botón 'Importar' en la columna de configuración de su fila de entradas y cargue el archivo csv exportado.",
  "Manage Configuration:": "Gestionar Configuración:",
  "You can view your configuration again as needed by clicking on the eye icon.": "Puede ver su configuración nuevamente según sea necesario haciendo clic en el icono de ojo.",
  "Open the tab 'List of Trades' in the TradingView backtester as shown in the image above.": "Abra la pestaña 'Lista de Operaciones' en el backtester de TradingView como se muestra en la imagen de arriba.",
  "Profits and Losses": "Ganancias y Pérdidas",
  "Total Wins": "Total de Ganancias",
  "Total Losses": "Total de Pérdidas",
  "Use deep backtest": "Usar deep backtest",
  "Start Date": "Fecha de inicio",
  "End Date": "Fecha de finalización",
  "Active dataset": "Conjunto de datos activo",
  "Manage Datasets": "Gestionar conjuntos de datos",
  "Number of Files": "Número de Archivos",
  "First Trade": "Primer Trade",
  "Last Trade": "Último Trade",
  "All files": "Todos los archivos",
  "Included files": "Archivos incluidos",
  "Number of Trades": "Número de operaciones",
  "Confirm Dataset Deletion": "Confirmar eliminación del conjunto de datos",
  "Are you sure you want to delete the dataset named": "¿Estás seguro de que quieres eliminar el conjunto de datos llamado",
  "Add New Dataset": "Agregar nuevo conjunto de datos",
  "Dataset Name": "Nombre del conjunto de datos",
  "Add": "Agregar",
  "Manage Data": "Gestionar datos",
  "Confirm Initial Capital": "Confirmar capital inicial",
  "Initial Capital from Config": "Capital inicial de la configuración",
  "Add Dataset": "Agregar conjunto de datos",
  "Timestamp": "Marca de tiempo",
  "days": "días",
};

// Reminder: Don't forget to translate the MUI X filter phrases.
export default translations;